import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from 'angular-web-storage';
import { AuthService } from '../auth.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, RouterModule, Routes, Router } from '@angular/router';
import { NetworkStatusService } from 'src/app/network-status.service.ts.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { ReleasenoteComponent } from '../releasenote/releasenote.component';
import { CompanyService } from '../company/company.service';
import { ReportsService } from '../reports/reports.service';
import { error } from 'console';
import { OtpDialogService } from '../otp-dialog/otp-dialog.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {
  public sidebarOpened = false;
  public cookieIp = "";
  firstname;
  lastname;
  image = '';
  companyLogo: any;
  companyName: any;
  approvalPasscode: number;
  roleId: number;
  feedbackMessage: string = '';
  feedbackSuccess: boolean = true;
  animatePasscode: boolean = false;
  toggleOffcanvas() {
    this.sidebarOpened = !this.sidebarOpened;
    if (this.sidebarOpened) {
      document.querySelector('.sidebar-offcanvas').classList.add('active');
    }
    else {
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }
  }
  constructor(public dialog: MatDialog, private cookieService: CookieService, config: NgbDropdownConfig, private router: Router, public session: SessionStorageService, public auth: AuthService, public companyService: CompanyService,
    public networkStatusService: NetworkStatusService, public rs: ReportsService, public ods: OtpDialogService
  ) {
    config.placement = 'bottom-right';
  }
  ngOnInit() {
    this.cookieIp = this.cookieService.get('campbell_app_ip_address');
    this.firstname = this.session.get('firstname');
    this.lastname = this.session.get('lastname');
    this.image = this.session.get('profileImage');
    this.companyName = this.session.get('companyName');
    this.approvalPasscode = this.session.get('approvalPasscode');
    this.roleId = this.session.get('roleid');

    this.networkStatusService.isOnline.subscribe(status => {
      if (status) {
        this.companyService.getSettingDetail((response) => {
          console.log("checkgetServerDetail", response);
          this.session.set('isShoreServer', response.isShoreServer);
        })
        if (this.session.get('companyIdLogo')) {
          this.companyService.getDataById(this.session.get('companyIdLogo'), (response) => {
            console.log("=======response====", response);
            if (response.responsecode === 200 || response.responsecode === '200') {
              this.companyLogo = response.data.profileImage;
            }
          })
        }
      }
    });
    this.session.set('isShoreServer', null);
  }

  Signoffsheet() {
    this.router.navigate(['/signoffsheet'])
  }

  Statussheet() {
    this.router.navigate(['/statussheet'])
  }

  logout() {
    const sessionKeys = ['profileImage', 'token', 'firstname', 'lastname', 'userSignature', 'userid', 'roleid', 'isShoreServer']
    sessionKeys.forEach(key => this.session.set(key, null));
    this.ods.clearOtpTimer();
    console.log("Clear Timer Succesfully");
    this.auth.logout();
  }

  openversion(data: any, id: any, index: any) {
    const dialogRef = this.dialog.open(ReleasenoteComponent, {
      width: "600px",
      height: "300px"
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  // copyPasscode(passcode: string): void {
  //   navigator.clipboard.writeText(passcode).then(() => {
  //     this.feedbackMessage = 'Copied Successfully';
  //     this.feedbackSuccess = true;
  //     this.clearFeedbackAfterDelay();
  //   }).catch(err => {
  //     this.feedbackMessage = 'Failed to copy passcode.';
  //     this.feedbackSuccess = false;
  //     this.clearFeedbackAfterDelay();
  //     console.error('Failed to copy: ', err);
  //   });
  // }

  copyPasscode(passcode: string): void {
    // Try modern Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(passcode).then(() => {
        this.showCopyFeedback(true);
      }).catch(err => {
        console.error('Clipboard API failed, using fallback:', err);
        this.fallbackCopyText(passcode);
      });
    } else {
      // Fallback for insecure context or unsupported browser
      this.fallbackCopyText(passcode);
    }
  }
  
  private fallbackCopyText(passcode: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = passcode;
  
    // Prevent scrolling to bottom
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
  
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
  
    try {
      const successful = document.execCommand('copy');
      this.showCopyFeedback(successful);
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.showCopyFeedback(false);
    }
  
    document.body.removeChild(textarea); 
  }
  
  private showCopyFeedback(success: boolean): void {
    this.feedbackMessage = success ? 'Copied Successfully' : 'Failed to copy passcode.';
    this.feedbackSuccess = success;
    this.clearFeedbackAfterDelay();
  }
  

  regeneratePasscode(): void {
    const userid = this.session.get('userid');
    this.rs.resetApprovalPasscode(userid).subscribe({
      next: () => {
        this.session.remove('approvalPasscode');
        this.fetchNewPasscode(userid);
      },
      error: (error) => {
        this.feedbackMessage = 'Error resetting passcode';
        this.feedbackSuccess = false;
        this.clearFeedbackAfterDelay();
        console.error('Error resetting passcode', error);
      }
    });
  }

  fetchNewPasscode(userid: number): void {
    this.rs.resetApprovalPasscode(userid).subscribe({
      next: (newPasscode) => {
        this.session.set('approvalPasscode', newPasscode);

        // Animate passcode change
        this.animatePasscode = false;
        setTimeout(() => {
          this.approvalPasscode = newPasscode;
          this.animatePasscode = true;
        }, 100); // Delay for animation trigger

        this.feedbackMessage = 'Passcode regenerated successfully';
        this.feedbackSuccess = true;
        this.clearFeedbackAfterDelay();
      },
      error: (error) => {
        this.feedbackMessage = 'Error fetching new passcode';
        this.feedbackSuccess = false;
        this.clearFeedbackAfterDelay();
        console.error('Error fetching new passcode', error);
      }
    });
  }

  clearFeedbackAfterDelay(): void {
    setTimeout(() => {
      this.feedbackMessage = '';
    }, 3000);
  }


}
